import styled from 'styled-components'
import { bp } from 'lib/core/resources/helpers/styled'
import homeTexture from 'resources/svg/home-texture.svg'

export const Wrapper = styled.div`
  background: url(${homeTexture});

  > div {
    ${props => props.theme.css.container};
    margin: auto;
    padding: 30px 40px 30px;
  }

  h1 {
    padding: 15px 0;
    border-bottom: 1px solid ${props => props.theme.palette.general.greyMutted};
    font-weight: normal;
  }

  .flex {
    justify-content: flex-end;
    flex-wrap: wrap;
    margin-bottom: 20px;

    a {
      text-decoration: none;
      color: ${props => props.theme.palette.primary.alphaDark};
    }
  }
`

export const TopBanner = styled.div`
  text-align: center;

  img {
    width: 100%;
  }
`

export const ComparisonContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  text-align: center;
  min-height: 650px;
  ${bp('sm')`
    justify-content: center;
  `}

  > div {
    width: 23%;
    min-width: 230px;
    margin-bottom: 15px;
    ${bp('sm')`
      width: 50%;
      min-width: 165px;
    `}
  }
`

export const SliderContainer = styled.div`
  .carousel {
    &__arrows {
      top: unset;
      bottom: -65px;
    }

    &__bottom {
      height: 100px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 14px;

      svg {
        height: 35px;
        width: 35px;
        fill: ${props => props.theme.palette.general.greyMutted};
        transform: rotate(30deg);
        margin-bottom: 10px;
      }
    }
  }
`
